import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { SharedService } from '../../shared/services/share.services';
import { AppMessages } from '../../shared/constants/messages';
import { AppConstants } from '../../shared/constants/constants';
import { Page } from '../../models/list/page.model';

@Component({
    selector: 'app-data-table',
    template: ''
})
export class TMBDataTableComponent implements OnDestroy {
    private subscription: Subscription;
    public appConstants = AppConstants;
    public page = new Page();
    public dataRow: any;
    public dataMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total // Footer total message
    };
    public customClasses = AppConstants.table.footerClasses;

    constructor(public sharedService: SharedService) {
        // get menu toggle action from shareService
        this.subscription = this.sharedService.getMenuToggle().subscribe(
            data => {
            this.updateTableLayout();
        });
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }

    updateTableLayout() {
        // refresh the layout
        if (this.dataRow) {
            this.dataRow = [...this.dataRow];
        }
    }

    /**
     * function to reload page but keep current page
     * @param currentPage 
     * @param dataRow 
     * @param isDelete 
     */
    reloadPage(currentPage, dataRow, isDelete = false) {
        let pageNumber = currentPage;
        if (isDelete && dataRow.length === 1) {
            pageNumber = (currentPage - 1) < 0 ? 0 : (currentPage - 1);
        }
        this.setPage({ offset: pageNumber });
    }

    /**
     * function should be override in inherit component
     * to call API get data for dataTable
     */
    setPage(pageInfo: any, data= null) {
        // must be override in inherit component
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/data-table/data-table.component.ts